class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.splideInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const sliderElement = this.querySelector('.splide');
    if (!sliderElement || !window.Splide) return;

    this.splideInstance = new window.Splide(sliderElement, {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: true,
      autoplay: false,
      interval: 4000,
      pauseOnHover: false,
    });

    this.splideInstance.mount();
  }

  disconnectedCallback() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }
  }
}

if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', TestimonialSlider);
}